import script from "./AppIconCreator.vue?vue&type=script&setup=true&lang=js"
export * from "./AppIconCreator.vue?vue&type=script&setup=true&lang=js"

import "./AppIconCreator.vue?vue&type=style&index=0&id=40660c9c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40660c9c"]])

export default __exports__